<template>
<div id="transferManage">
  <div class="search" style="margin-top:30px;">
    <h2 style="font-size:18px;">任务详情</h2>
  </div>
  <div class="search" style="width:100%;height:100%;">
    <div class="title">
      <div class="searchInline">
        <p>任务名称:{{taskDetailName}}</p><br/>
        <p>客服数量:{{$route.query.amountService}}</p><br/>
        <p>已呼叫数/客户数量:{{$route.query.callNums}}/{{totalResult}}</p><br/>
        <p>接通数量:{{$route.query.connectNum}}</p>
      </div>
      <el-button type="primary" @click="backBtn">返回上一级</el-button>
    </div>
  </div>
  <div class="contentView">
    <el-table :data="tableData" style="width: 100%;">
      <el-table-column
        prop="userName"
        label="客户名称"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="taskPhone"
        label="电话号码"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="bindWorknumber"
        label="执行客服"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="callNum"
        label="呼叫次数"
        min-width="100">
      </el-table-column>
      <el-table-column
        label="是否接通"
        min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.callStatus == 10">未呼叫</span>
          <span v-if="scope.row.callStatus == 0">状态未同步</span>
          <span v-if="scope.row.callStatus == 20">未接通</span>
          <span v-if="scope.row.callStatus == 30">已通话</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10,20,30,40]"
        :page-size="searchParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult">
      </el-pagination>
    </div>
  </div>
</div>
</template>

<script>
import { devCode } from '@/http/baseUrl';
export default {
  name: 'transferManage',
  data () {
    return {
      searchParams: {
        mobile: '',
        Name: '',
        isAccount: '',
        time: [],
        ffTime: [],
        pageSize: 10,
        pageIndex: 0
      },
      ids: '',
      taskDetailName: '',
      tableData: [],
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      dialog: {
        submit: {
          show: false,
          userName: '',
          manageId: '',
          batchNo: ''
        }
      }
    };
  },
  created () {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList () {
      this.axios.get('/doubleTask/pageDetailtaskList' + devCode, {
        params: {
          taskId: this.$route.query.taskId,
          pageIndex: this.searchParams.pageIndex,
          pageSize: this.searchParams.pageSize
        }
      }).then(res => {
        console.log(res, '22');
        if (res.data.isSuccess) {
          this.tableData = res.data.resultData.pageListData;
          this.taskDetailName = res.data.resultData.pageListData[0].taskDetailName;
          this.totalResult = res.data.resultData.totalResult;
          this.totalPage = res.data.resultData.totalPage;
        };
      });
    },
    // 返回上一级
    backBtn () {
      if (this.$route.query.type === 'myTask') {
        this.$router.push({name: 'myTask', query: {curMenu: '0'}});
      } else {
        this.$router.push({name: 'isTruetask'});
      }
    },
    // 更改pageSize
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.el-table th div.renderHeader{
  line-height: 14px; padding: 0; margin-top: 4px;
  span{margin-right: 5px;}
  i{cursor: pointer;}
}
.title{
  // height: 80px;
  width: 100%;
  background: #f4f4f4;
  padding: 20px 30px;
  display:flex;
  justify-content: space-between;
}
.title .searchInline{
  width: 70%;
  // display: flex;
  // justify-content: space-between;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/taskManage/taskDetail.vue